import { UI_SYSTEM } from '../constants/mixpanel';

const aMetaData = (email = 'n/a', id = 'n/a', first_name = 'n/a', last_name = 'n/a', is_super_admin = false) => {
  return {
    email,
    id,
    first_name,
    last_name,
    is_super_admin,
  };
};

const extractUserInformation = () => {
  const raw = localStorage.getItem('persist:role');
  let meta = aMetaData();
  if (raw !== null) {
    const data = JSON.parse(raw);
    if (data.user !== 'null') {
      const { email, id, first_name, last_name, is_super_admin } = JSON.parse(data.user);
      meta = aMetaData(email, id, first_name, last_name, is_super_admin);
    }
  }
  return meta;
};

export const reportBusinessActionToMixpanel = (mixpanel, event, meta = {}) => {
  if (mixpanel.config?.token) {
    const normalizedEvent = event ? event.replaceAll(' ', '-').toLowerCase() : 'unknown';
    const { id, email, first_name, last_name, is_super_admin } = extractUserInformation();

    mixpanel.track(normalizedEvent, {
      distinct_id: id,
      system: UI_SYSTEM,
      email,
      id,
      first_name,
      last_name,
      is_super_admin,
      ...meta,
    });
  }
};
